export const helix = {
  name: 'onify:helix',
  // Don't include file extension of css or sass file
  cssPath: 'css/helix-light',
  vuetify: {
    defaults: {
      VTooltip: {
        openDelay: 1000,
      },
      VTextField: {
        variant: 'filled',
      },
      VSelect: {
        variant: 'filled',
      },
      VFileInput: {
        variant: 'filled',
      },
      VTextarea: {
        variant: 'filled',
      },
      VAutocomplete: {
        variant: 'filled',
      },
      VBtn: {
        variant: 'flat',
        size: 'large',
      },
      VTabs: {
        hideSlider: true,
      },

      HFiltersContainer: {
        VExpansionPanelTitle: {
          color: 'filters-container',
          static: true,
        },
      },

      HFilterDatetime: {
        VCombobox: {
          hideDetails: false,
          variant: 'outlined',
          density: 'compact',
          prependInnerIcon: 'mdi:mdi-calendar-range',
        },
        VIcon: {
          size: '26',
          icon: 'mdi:mdi-close-circle',
        },
      },

      HWorkspace: {
        HBulletin: {
          VCard: {
            color: 'workspace-bulletin',
          },
          HActionLink: {
            HScopedBulletinActionBtn: {
              size: 'small',
              variant: 'text',
              color: 'primary',
              icon: false,
              appendIcon: 'mdi:mdi-chevron-right',
            },
          },
        },
        HShortcut: {
          color: 'workspace-shortcut',
        },
      },

      HShortcut: {
        VBadge: {
          color: 'secondary',
          inline: true,
        },
      },

      HWorkspaceItem: {
        HScopedWorkspaceItemMoreTagsIcon: {
          icon: 'mdi:mdi-dots-horizontal',
        },
      },

      HBulletin: {
        HScopedBulletinAcknowledgeBtn: { variant: 'text', size: 'x-small', icon: 'fa fa-times' },
        HScopedBulletinActionBtn: {
          size: 'default',
          variant: 'elevated',
          icon: false,
        },
      },

      HHelixLayout: {
        VAppBar: {
          color: 'toolbar',
          flat: true,
        },
        VAppBarNavIcon: {
          variant: 'text',
          color: 'on-toolbar',
          size: 'default',
        },
      },

      HNavigationMenu: {
        VBtn: {
          variant: 'text',
          icon: 'mdi:mdi-open-in-new',
          size: 'small',
        },
        VSheet: {
          color: 'background',
          height: '109px',
          class: ['border-b-thin'],
        },
        HScopedNavigationMenuLogoAvatar: {
          size: '90px',
        },
      },
      HSearchItems: {
        VTextField: {
          variant: 'solo',
          density: 'compact',
          color: 'secondary',
          singleLine: true,
          flat: true,
        },
      },
      HNotificationDrawer: {
        HScopedNotificationDrawerMarkAllBtn: {
          size: 'x-small',
          variant: 'text',
          color: 'primary',
        },
        HScopedNotificationDrawerCloseBtn: {
          size: 'x-small',
          icon: 'mdi:mdi-close',
          variant: 'text',
        },
      },
      HNotificationItem: {
        VBtn: {
          size: 'regular',
        },
        VIcon: {
          variant: 'plain',
          icon: 'mdi:mdi-circle',
        },
      },

      HItemCard: {
        HScopedItemCardActionBtn: {
          color: 'primary',
        },
        HScopedItemCardMenuBtn: {
          color: 'secondary',
          appendIcon: 'mdi:mdi-menu-down',
        },
      },

      HBreadcrumbs: {
        VBtn: {
          size: 'small',
          variant: 'text',
          icon: 'mdi:mdi-arrow-left',
          color: 'on-breadcrumb',
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        /* 
          Vuetify Core Colors (See MD3 color roles: https://m3.material.io/styles/color/roles)
          Note: It is not confirmed if vuetify is using all of the color roles defined by MD3.
          Conversely, not all colors used by vuetify are defined by MD3.
        */
        primary: '#5425CB',
        secondary: '#FBB924',
        tertiary: '#09B8D0',
        neutral: '#F1F5FA',
        error: '#A0000E',
        success: '#1B6D24',
        warning: '#695F02',
        info: '#005DB7',
        background: '#F8FAFC',
        'on-background': '#000E4B',
        'on-primary': '#FFFFFF',
        'on-secondary': '#4D3600',
        'on-tertiary': '#FFFFFF',
        'on-error': '#FFFFFF',
        outline: '#C9C6C5',
        border: '#C9C6C5',
        surface: '#FFFFFF',
        'on-surface': '#000E4B',
        'surface-variant': '#6B43E2',
        'on-surface-variant': '#444749',
        disabled: '#C9C6C5',

        // Additional Colors
        'primary-2': '#885DF6',
        'primary-3': '#6747DF',
        'secondary-2': '#FA7A17',
        'tertiary-2': '#3CB6F8',
        'tertiary-3': '#606DF2',
        'neutral-variant': '#F3F0F0',
        'neutral-variant-90': '#D1D5DB',
        'neutral-80': '#CBD5E1',
        'neutral-90': '#E2E8F0',
        'neutral-99': '#F8FAFC',
        'neutral-100': '#FFFFFF',
        'secondary-60': '#FBB924',
        'secondary-95': '#FFEED7',
        'neutral-40': '#605D62',
        'neutral-70': '#94A3B8',
        'on-neutral-100': '#000E4B',
        'surface-2': '#FFFBFF',
        'content-primary': '#6B43E2',

        // Admin
        get 'admin-total-audits'() {
          return this.primary;
        },

        get 'admin-process-completed'() {
          return this.success;
        },

        get 'admin-process-running'() {
          return this.info;
        },

        get 'admin-process-stopped'() {
          return this.error;
        },

        // Breadcrumbs
        get 'breadcrumb-hover'() {
          return this['surface-2'];
        },

        get 'on-breadcrumb'() {
          return this.primary;
        },

        // Shortcuts
        get 'shortcut-icon'() {
          return this['on-tertiary'];
        },

        get 'shortcut-icon-bg'() {
          return this['tertiary-2'];
        },

        get 'shortcut-icon-bg-2'() {
          return this['tertiary-3'];
        },

        get 'workspace-shortcut'() {
          return this['neutral-100'];
        },

        // Navigation Menu
        get 'navigation-menu'() {
          return this['neutral-100'];
        },

        // Workspaces
        get 'workspace-icon'() {
          return this.surface;
        },

        get 'workspace-icon-bg'() {
          return this.secondary;
        },

        get 'workspace-icon-bg-2'() {
          return this['secondary-2'];
        },

        get 'workspace-footer'() {
          return this.surface;
        },

        get 'on-workspace-footer'() {
          return this['on-surface'];
        },

        get 'workspace-bulletin'() {
          return this['neutral-100'];
        },

        get 'on-workspace-bulletin'() {
          return this['on-neutral-100'];
        },

        // Bulletins
        get 'bulletin-informational'() {
          return this['primary'];
        },

        get 'on-bulletin-informational'() {
          return this['on-primary'];
        },

        get 'bulletin-warning'() {
          return this.warning;
        },

        get 'on-bulletin-warning'() {
          return this['on-surface'];
        },

        get 'bulletin-critical'() {
          return this.error;
        },

        get 'on-bulletin-critical'() {
          return this['on-error'];
        },

        get 'bulletin-success'() {
          return this.success;
        },

        get 'on-bulletin-success'() {
          return this['on-surface'];
        },

        get 'bulletin-informational-button'() {
          return this['on-surface'];
        },

        get 'on-bulletin-informational-button'() {
          return this.surface;
        },

        get 'bulletin-warning-button'() {
          return this['on-surface'];
        },

        get 'bulletin-critical-button'() {
          return this['on-surface'];
        },

        get 'bulletin-success-button'() {
          return this['on-surface'];
        },

        get 'bulletin-informational-button-hover'() {
          return this['bulletin-informational-button'];
        },

        get 'on-bulletin-informational-button-hover'() {
          return this['on-bulletin-informational-button'];
        },

        get 'bulletin-warning-button-hover'() {
          return this['bulletin-warning-button'];
        },

        get 'bulletin-critical-button-hover'() {
          return this['bulletin-critical-button'];
        },

        get 'bulletin-success-button-hover'() {
          return this['bulletin-success-button'];
        },

        // Scrollbar
        get scrollbar() {
          return this.primary;
        },

        get 'scrollbar-track'() {
          return this['surface-variant'];
        },

        // Badges
        get 'badge-primary'() {
          return this.primary;
        },

        get 'on-badge-primary'() {
          return this['on-primary'];
        },

        get 'badge-secondary'() {
          return this.secondary;
        },

        get 'on-badge-secondary'() {
          return this['on-secondary'];
        },

        get 'badge-tertiary'() {
          return this.tertiary;
        },

        get 'on-badge-tertiary'() {
          return this['on-tertiary'];
        },

        // Layout
        get toolbar() {
          return this.surface;
        },

        get 'on-toolbar'() {
          return this['on-surface'];
        },

        // Process State
        get 'process-state-active'() {
          return this.primary;
        },

        get 'on-process-state-active'() {
          return this['on-primary'];
        },

        // Process State
        get 'process-state-inactive'() {
          return this.secondary;
        },

        get 'on-process-state-inactive'() {
          return this['on-secondary'];
        },

        get 'process-state-skipped'() {
          return this.secondary;
        },

        get 'on-process-state-skipped'() {
          return this['on-secondary'];
        },

        get 'process-state-done'() {
          return this.success;
        },

        get 'on-process-state-done'() {
          return this['on-success'];
        },

        get 'process-state-error'() {
          return this.error;
        },

        get 'on-process-state-error'() {
          return this['on-error'];
        },

        // Misc.
        get 'page-loader'() {
          return this.surface;
        },

        get 'filters-container'() {
          return this['secondary-95'];
        },

        // Process Simple
        get 'simple-process-step-done'() {
          return this.success;
        },

        get 'simple-process-step-error'() {
          return this.error;
        },

        get 'simple-process-completed'() {
          return this.success;
        },

        get 'simple-process-stopped'() {
          return this.error;
        },

        get 'simple-process-running'() {
          return this.warning;
        },

        get 'simple-process-default'() {
          return this['neutral-70'];
        },

        get 'filter-group-badge'() {
          return this.primary;
        },

        get 'on-filter-group-badge'() {
          return this['on-primary'];
        },

        get 'filter-group-active'() {
          return this.primary;
        },

        get 'on-filter-group-active'() {
          return this['on-primary'];
        },
      },
    },
  },
};
